/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * How a Novelist publisher delivers, set per publisher by a moderator. Not an
 * ``ImportChannel``: that records how one run entered, and one delivery method yields runs of
 * several channels.
 */
export type NovelistDeliveryMethod = typeof NovelistDeliveryMethod[keyof typeof NovelistDeliveryMethod];


export const NovelistDeliveryMethod = {
  ftp: 'ftp',
} as const;
